import React from 'react';
import { Box, Typography, Button, Modal, Stack } from '@mui/material';
import { ACTION_BLUE } from '../../theme/theme';

interface LogoutConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

/**
 * Asks the user to confirm before signing out.
 *
 * The request itself stays in the caller: this component only decides whether
 * the user meant to press the button, so it can be reused wherever a logout
 * is triggered from.
 */
const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  loading = false,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 1,
          boxShadow: 24,
          p: 16,
          m: 8,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textAlign: 'right',
            color: '#25282E',
            fontSize: 16,
            fontFamily: 'IRANYekanXFaNum',
            fontWeight: 700,
            lineHeight: '20px',
          }}
        >
          خروج از حساب کاربری
        </Typography>

        <Typography
          sx={{
            mt: 2,
            textAlign: 'right',
            color: '#60646E',
            fontSize: 14,
            fontFamily: 'IRANYekanXFaNum',
            fontWeight: 600,
          }}
        >
          آیا مطمئن هستید که می‌خواهید از حساب کاربری خود خارج شوید؟
        </Typography>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mt: 16 }}
        >
          <Button
            variant="contained"
            disabled={loading}
            sx={{
              backgroundColor: '#FFD6DB',
              color: '#EF4056',
              fontSize: 14,
              fontFamily: 'IRANYekanXFaNum',
              fontWeight: 700,
              '&:hover': {
                backgroundColor: '#FFD6DB',
              },
            }}
            onClick={onConfirm}
          >
            {loading ? 'در حال خروج...' : 'تایید و خروج'}
          </Button>

          <Button
            variant="contained"
            disabled={loading}
            sx={{
              backgroundColor: ACTION_BLUE,
              color: 'white',
              fontSize: 12,
              fontFamily: 'IRANYekanXFaNum',
              fontWeight: 500,
              '&:hover': {
                backgroundColor: ACTION_BLUE,
              },
            }}
            onClick={onClose}
          >
            انصراف
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default LogoutConfirmModal;
